export default {
  phone: /^1(3|4|5|6|7|8|9)\d{9}$/,
  pwdreg: /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,18}$/,
  pwdreg2: /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,20}$/,
  idNumber: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  email: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
  userreg: /^.{6,18}$/,
  isZheng:/^\+?[0-9][0-9]*$/,
  // isZheng:/\D|^0/g,
  isXiao:/^(([0-9])|([1-9]([0-9]+)))(.[0-9]+)$/,
  // isPercent:/^(1|(0(.\d+)?))$/
  isPercent:/^(0(\.\d{1,3})?|1(\.0{1,3})?)$/
  
}